import Vue from 'vue';
import Vuex from 'vuex';
import common from './common';
import createLogger from 'vuex/dist/logger';

Vue.use(Vuex);

let moduleConfig = null;
const isDebug = process.env.NODE_ENV !== 'production';
if (isDebug ||
  process.env.APP_MODE === 'open') {
  moduleConfig = {
    open: require('./open').default
  };
} else {
  moduleConfig = {};
}

export default new Vuex.Store({
  ...common,
  modules: moduleConfig,
  strict: isDebug,
  plugins: isDebug ? [createLogger()] : []
});



// WEBPACK FOOTER //
// ./src/store/index.js